import { client } from '../../../api/Api';

const fetchResults = id =>
  client.getDriveUpListings(id).then(result => result.data);

export default query =>
  new Promise(resolve => {
    let queryString = query;

    if (query.substring(0, 1) === '#') {
      queryString = query.substring(1);
    }

    const isThreeNumbers = /^\d{3,}/;

    if (!queryString.match(isThreeNumbers)) {
      return resolve([]);
    }

    return fetchResults(queryString).then(resolve);
  });
